export default "__VITE_ASSET__C29i0zBu__"